import { createApp } from 'vue';
import { createPinia } from 'pinia';
import LiveApp from './LiveApp.vue';
import router from './router';
import { installGlobalErrorCapture, trace } from './utils/onScreenLog';

// Hook the on-screen log before anything else runs, so even boot-time failures are captured
// and readable inside the Telegram Mini App (where DevTools are unavailable).
installGlobalErrorCapture();

// Lightweight entry for the end-user "Live Radar" app: no detection pipeline (ONNX),
// no admin tooling — just the geolocation store + map feed.
const app = createApp(LiveApp);
app.use(createPinia());
// The radar tree mounts MyEventsFeed, whose "📊 Графики отладки" button navigates to
// the radar-debug route (and RadarDebugPage reads its :id from the route). Without an
// installed router, useRouter() returns undefined and router.push() throws, so we must
// register it here — same shared router instance as main.ts.
app.use(router);

// Contain component errors: log them with the real stack (window.onerror would mask
// cross-origin ones as "Script error.") and keep the app interactive instead of letting
// one bad render freeze every button on the page.
app.config.errorHandler = (err, _instance, info) => {
  trace.error('[Vue]', err, `(${info})`);
};

// If opened inside Telegram, expand the Mini App to full height.
const tg = (window as unknown as { Telegram?: { WebApp?: { ready: () => void; expand: () => void } } })
  .Telegram?.WebApp;
if (tg) {
  tg.ready();
  tg.expand();
}

app.mount('#app');
